import { BalanseGoods } from "components/context/StoreProvider";
import { useContext } from "react";

export default function useBalanseGoods() {
  return useContext(BalanseGoods);
}
